import { Template, TemplateSection, SectionField, SectionFieldInputTypeOld, SectionFieldInputType } from '../typings';

let templateValues: Template;

export enum FieldInputType {
  ShortText = 'ShortText',
  LongText = 'LongText',
  NumberInteger = 'NumberInteger',
  NumberDecimal = 'NumberDecimal',
  SingleSelect = 'SingleSelect',
  MultiSelect = 'MultiSelect',
  DateAndTime = 'DateAndTime',
  Date = 'Date',
  Time = 'Time',
  Toggle = 'Toggle',
  Photo = 'Photo',
  Signature = 'Signature',
  Checkbox = 'Checkbox',
  Label = 'Label'
}

export const setTemplateValues = (body: Template) => {
  templateValues = body;
};

export const getTemplateValues = () => templateValues;

/**
 * @function
 * @name updateTemplateCountryCode
 * @description Add country code into template data.
 * Note: Country code is needed when call /portal-template-pdf endpoint
 */
export const updateTemplateCountryCode = (countryCode: string) => {
  const countryCodes = ['CN', 'FR', 'ID', 'JP', 'TW'];
  templateValues.countryCode = countryCodes.includes(countryCode.toUpperCase()) ? countryCode : 'EN';
};

// Update the template URL when preview popup is opened
export function updateTemplateURL(state: any, title: string, url: string) {
  if (typeof window !== 'undefined' && typeof url !== 'undefined') {
    window.history.pushState(state, title, url);
  }
}

/**
 * @function
 * @name setFieldInputType
 * @description Convert the fieldInputType to Graphql enum values
 * @returns {SectionFieldInputType}
 */
export function setFieldInputType(fieldInputType: SectionFieldInputTypeOld | SectionFieldInputType): SectionFieldInputType {
  switch (fieldInputType) {
    case 'NUMBER_INTEGER': {
      return FieldInputType.NumberInteger;
    }
    case 'DATE': {
      return FieldInputType.Date;
    }
    case 'LONGTEXT': {
      return FieldInputType.LongText;
    }
    case 'MULTISELECT': {
      return FieldInputType.MultiSelect;
    }
    case 'SHORTTEXT': {
      return FieldInputType.ShortText;
    }
    case 'TIME': {
      return FieldInputType.Time;
    }
    case 'DATEANDTIME': {
      return FieldInputType.DateAndTime;
    }
    case 'NUMBER_DECIMAL': {
      return FieldInputType.NumberDecimal;
    }
    case 'PHOTO': {
      return FieldInputType.Photo;
    }
    case 'SINGLESELECT': {
      return FieldInputType.SingleSelect;
    }
    case 'TOGGLE': {
      return FieldInputType.Toggle;
    }
    case 'SIGNATURE': {
      return FieldInputType.Signature;
    }
    case 'CHECKBOX': {
      return FieldInputType.Checkbox;
    }
    case 'LABEL': {
      return FieldInputType.Label;
    }
    default: {
      return fieldInputType;
    }
  }
}

/**
 * @function
 * @name convertFieldInputType
 * @description Update the value of fieldInputType to the new one for the existing templates
 * @returns {Template}
 */
export function convertFieldInputType(template: Template): Template {
  const { templateSections } = template;
  const templateData = templateSections.map((eachSection: TemplateSection) => ({
    ...eachSection,
    sectionFields: eachSection.sectionFields.map((eachSectionField: SectionField) => ({
      ...eachSectionField,
      fieldInputType: setFieldInputType(eachSectionField.fieldInputType)
    }))
  }));
  return { ...template, templateSections: templateData };
}
